import React from 'react';

import { FormControl, FormControlLabel, FormLabel, Radio, RadioGroup, TableRow } from '@material-ui/core';

import { NoBorderCell } from 'components/common/table/TableStyle';
import { BoldText } from '../ModalContent.styled';
import { CouponType, couponTypeLabel } from 'constants/member/connect';
import { CouponFormField } from 'types/member';

interface Props {
  couponType: CouponType;
  onChangeValue: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const Type = ({ couponType, onChangeValue }: Props) => {
  return (
    <TableRow>
      <NoBorderCell>
        <BoldText>Type</BoldText>
      </NoBorderCell>
      <NoBorderCell align={'left'}>
        <FormControl component="fieldset">
          <RadioGroup
            row
            name={CouponFormField.TYPE}
            value={couponType}
            onChange={onChangeValue}
          >
            <FormControlLabel
              value={CouponType.PRICE}
              control={<Radio />}
              label={couponTypeLabel[CouponType.PRICE]}
              style={{ marginRight: '70px' }}
            />
            <FormControlLabel
              value={CouponType.RATE}
              control={<Radio />}
              label={couponTypeLabel[CouponType.RATE]}
            />
          </RadioGroup>
        </FormControl>
      </NoBorderCell>
    </TableRow>
  );
};

export default Type;
